import { ShieldCheck } from "lucide-react";

/**
 * Thin marketing banner shown above every calculator page hero. Carries the
 * unified campaign headline so every calculator URL doubles as a landing
 * page suitable for direct paid-ad traffic.
 */
export default function CampaignBanner({ kicker }) {
  return (
    <div className="bg-zinc-900 text-white border-b border-zinc-800" data-testid="campaign-banner">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-3 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <ShieldCheck className="h-4 w-4 text-amber-300 flex-shrink-0" />
          <div className="min-w-0">
            {kicker && (
              <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-400">{kicker}</div>
            )}
            <div className="text-sm font-medium leading-tight">
              Understand your situation before speaking to a lawyer.
            </div>
          </div>
        </div>
        <div className="text-[11px] tracking-wider uppercase text-zinc-400 flex items-center gap-4">
          <span>No commitment</span>
          <span className="hidden sm:inline opacity-40">·</span>
          <span className="hidden sm:inline">Free to use</span>
          <span className="hidden md:inline opacity-40">·</span>
          <span className="hidden md:inline">Built by EH Inc</span>
        </div>
      </div>
    </div>
  );
}
